import script from "./Wizard.vue?vue&type=script&lang=ts&setup=true"
export * from "./Wizard.vue?vue&type=script&lang=ts&setup=true"

import "./Wizard.vue?vue&type=style&index=0&id=6118f3ae&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6118f3ae"]])

export default __exports__